import { html, nothing, TemplateResult } from "lit";

/**
 * Badge semi-transparent « © {copyright} » pour les illustrations.
 * Retourne nothing si le copyright est vide.
 */
export function renderImageCopyrightBadge(
  copyright: string | null | undefined,
  options?: { corner?: boolean },
): TemplateResult | typeof nothing {
  const text = (copyright ?? "").trim();
  if (!text) return nothing;
  const label = `© ${text}`;
  const cornerClass = options?.corner ? " image-copyright-badge--corner" : "";
  return html`<span class="image-copyright-badge${cornerClass}" title="${label}"
    >${label}</span
  >`;
}
